module.exports = __webpack_public_path__ + "static/img/bg.b534e8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/four/bg.png
// module id = 0FxZ
// module chunks = 1